import React, { useState, useEffect, useRef } from 'react';
import Accordian from '../../../utils/accordion';
// import "./style.scss";

function Courses(props) {
	const courses_data = props?.islamicCoursesData.length ? props?.islamicCoursesData[0] : null;
	// console.log(courses_data);
	let data = courses_data?.course_accordion[0];
	let islamicStudies = [];
	if (data && Object.keys(data).length) {
		islamicStudies = data?.course_accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}

	const [islamicStudiesTitle, setislamicStudiesTitle] = useState(data?.heading);
	const [islamicStudiesSubTitle, setislamicStudiesSubTitle] = useState(data?.subHeading);
	const [islamic, setislamicStudies] = useState(islamicStudies);

	data = courses_data?.course_accordion[1];
	let electiveData = [];
	if (data && Object.keys(data).length) {
		electiveData = data?.course_accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}

	const [electiveTitle, setElectiveTitle] = useState(data?.heading);
	const [electiveSubTitle, setElectiveSubTitle] = useState(data?.subHeading);
	const [elective, setElective] = useState(electiveData);

	data = courses_data?.course_accordion[2];
	let theologyData = [];
	if (data && Object.keys(data).length) {
		theologyData = data?.course_accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}

	const [theologyTitle, setTheologyTitle] = useState(data?.heading);
	const [theologySubTitle, setTheologySubTitle] = useState(data?.subHeading);
	const [theology, setTheology] = useState(theologyData);


	data = courses_data?.course_accordion[3];
	let leadershipData = [];
	if (data && Object.keys(data).length) {
		leadershipData = data?.course_accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}

	const [leadershipTitle, setLeadershipTitle] = useState(data?.heading);
	const [leadershipSubTitle, setLeadershipSubTitle] = useState(data?.subHeading);
	const [leadership, setLeadership] = useState(leadershipData);

	data = courses_data?.course_accordion[4];
	let educationData = [];
	if (data && Object.keys(data).length) {
		educationData = data?.course_accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}

	const [educationTitle, setEducationTitle] = useState(data?.heading);
	const [educationSubTitle, setEducationSubTitle] = useState(data?.subHeading);
	const [education, setEducation] = useState(educationData);

	data = courses_data?.course_accordion[5];
	let chaplaincyData = [];
	if (data && Object.keys(data).length) {
		chaplaincyData = data?.course_accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}

	const [chaplaincyTitle, setChaplaincyTitle] = useState(data?.heading);
	const [chaplaincySubTitle, setChaplaincySubTitle] = useState(data?.subHeading);
	const [chaplaincy, setChaplaincy] = useState(chaplaincyData);

	data = courses_data?.course_accordion[6];
	let chaplaincyElectiveData = [];
	if (data && Object.keys(data).length) {
		chaplaincyElectiveData = data?.course_accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});
	}

	const [chaplaincyElectiveTitle, setChaplaincyElectiveTitle] = useState(data?.heading);
	const [chaplaincyElectiveSubTitle, setChaplaincyElectiveSubTitle] = useState(data?.subHeading);
	const [chaplaincyElective, setChaplaincyElective] = useState(chaplaincyElectiveData);

    data = courses_data?.course_accordion[7];
    let interData = [];
    if (data && Object.keys(data).length) {
        interData = data?.course_accordions?.map((key, index) => {
            return {
                heading: key.heading,
                content: key.content,
                open: false
            };
        });
    }

    const [interTitle, setInterTitle] = useState(data?.heading);
    const [interSubTitle, setInterSubTitle] = useState(data?.subHeading);
    const [inter, setInter] = useState(interData);


	return (
		<>
			<div className="container course-page">
				{/*<h1 className="text-center headingF headingF-sm"> Course Descriptions</h1>*/}
				<h1 className="text-center headingF headingF-sm"> {props?.islamicCoursesData[0]?.course_header?.heading} </h1>
				<div className="text-center">
					<div className="scroll-down">SCROLL <span className="down"></span></div>
					<div className="col-6"><p>
						{props?.islamicCoursesData[0]?.course_header?.content}
						{/*This is a listing of all credit-bearing courses offered by Bayan, generally organized by field, in fulfillment*/}
						{/*of degree program requirements in the M.Div. and M.A. degree programs at Chicago Theological*/}
						{/*Seminary. The courses are scheduled in the academic calendar in varying degrees of frequency, based*/}
						{/*on program requirements. Required core courses are more routinely offered, whereas elective courses*/}
						{/*are rotated to allow for greater variation and opportunity to study with diverse visiting faculty. Most*/}
						{/*courses are offered once every two academic years.*/}
					</p></div>
				</div>
				{/*<h2>ISLAMIC STUDIES (Core Courses)</h2>*/}
				<h2>{islamicStudiesTitle??''}</h2>
				<div className="col-6">
					<div>
						{/*{islamicStudiesData}*/}
						{islamic.length ? <Accordian accordions={islamic} setAccordions={setislamicStudies} /> : null}
						{/*<Accordian accordions={islamicAccordions} setAccordions={setIslamicAccordions} />*/}
					</div>
				</div>
				{/*<h2>Islamic/Muslim Studies (General Elective Courses)</h2>*/}
				<h2>{electiveTitle??''}</h2>
				<div className="col-6">
					{elective.length ? <Accordian accordions={elective} setAccordions={setElective} /> : null}
					{/*<div>*/}
					{/*	<Accordian accordions={muslinAccordions} setAccordions={setMuslimAccordions} />*/}
					{/*</div>*/}
				</div>
				{/*<h2>Islamic Theology (Concentration Elective Courses)</h2>*/}
				<h2>{theologyTitle??''}</h2>
				<div className="col-6">
					{theology.length ? <Accordian accordions={theology} setAccordions={setTheology} /> : null}
					{/*<div>*/}
					{/*	<Accordian accordions={advancedAccordions} setAccordions={setAdvancedAccordions} />*/}
					{/*</div>*/}
				</div>
				{/*<h2>Islamic Leadership (Concentration Elective Courses)</h2>*/}
				<h2>{leadershipTitle??''}</h2>
				<div className="col-6">

					{leadership.length ? <Accordian accordions={leadership} setAccordions={setLeadership} /> : null}
					{/*<div>*/}
					{/*	<Accordian accordions={leaderAccordions} setAccordions={setLeaderAccordions} />*/}
					{/*</div>*/}
				</div>
				{/*<h2>Islamic Education (Concentration Courses)</h2>*/}
				<h2>{educationTitle??''}</h2>
				<div className="col-6">
					{education.length ? <Accordian accordions={education} setAccordions={setEducation} /> : null}
					{/*<div>*/}
					{/*	<Accordian accordions={FiveAccordions} setAccordions={setFiveAccordions} />*/}
					{/*</div>*/}
				</div>
				{/*<h2>Islamic Chaplaincy (Core Courses)</h2>*/}
				<h2>{chaplaincyTitle??''}</h2>
				<div className="col-6">
					{chaplaincy.length ? <Accordian accordions={chaplaincy} setAccordions={setChaplaincy} /> : null}
					{/*<div>	*/}
					{/*	<Accordian accordions={ThreeAccordions} setAccordions={setThreeAccordions} />*/}
					{/*</div>*/}
				</div>

				{/*<h2>Islamic Chaplaincy (Concentration Elective Courses)</h2>*/}
				<h2>{chaplaincyElectiveTitle??''}</h2>
				<div className="col-6">
					{chaplaincyElective.length ? <Accordian accordions={chaplaincyElective} setAccordions={setChaplaincyElective} /> : null}
					{/*<div>*/}
					{/*	<Accordian accordions={FourAccordions} setAccordions={setFourAccordions} />*/}
					{/*</div>*/}
				</div>
				{/*<h2>Interfaith and Intra-Faith Studies</h2>*/}
				<h2>{interTitle??''}</h2>
				<div className="col-6">
                    {inter.length ? <Accordian accordions={inter} setAccordions={setInter} /> : null}
					{/*<div>*/}
					{/*	<Accordian accordions={SixAccordions} setAccordions={setSixAccordions} />*/}
					{/*</div>*/}
				</div>
				{/*<h2>Arabic</h2>*/}
				{/*<h2>{arabicTitle??''}</h2>*/}
				<div className="col-6">
					{/*{arabic.length ? <Accordian accordions={arabic} setAccordions={setarabic} /> : null}*/}
					{/*<div>*/}
					{/*	<Accordian accordions={arabicAccordions} setAccordions={setArabicAccordions} />*/}
					{/*</div>*/}
				</div>
				<br></br>
				<br></br>
			</div>
		</>
	);
}

export default Courses;
